// This file was automatically generated by tools management permissions. It should not be changed manually
export const SC_PERMS = {
	DATA: ":lib:commons/basis_Perms.js",
	DO: ":lib:commons/basis_Perms.js",
	SAAS: ":lib:saas/saas_Perms.js",
	admin: ":lib:commons/basis_Perms.js",
	adminSyst: ":lib:commons/basis_Perms.js",
	deploy: ":lib:commons/basis_Perms.js",
	read: ":lib:commons/basis_Perms.js",
	use: ":lib:commons/basis_Perms.js",
	write: ":lib:commons/basis_Perms.js",
	"admin.node": ":lib:wsp/wsp_Perms.js",
	"admin.node.configRoles": ":lib:wsp/wsp_Perms.js",
	"admin.node.configRoles.byAdmin": ":lib:wsp/wsp_Perms.js",
	"commit.drf": ":lib:wsp/wsp_Perms.js",
	"revert.drf": ":lib:wsp/wsp_Perms.js",
	"update.outsideLayer": ":lib:wsp/wsp_Perms.js",
	"delete.drvOverride": ":lib:wsp/wsp_Perms.js",
	"mark.drvOverrideDone": ":lib:wsp/wsp_Perms.js",
	generate: ":lib:wsp/wsp_Perms.js",
	"read.gen": ":lib:wsp/wsp_Perms.js",
	"deletePermanently.history": ":lib:wsp/wsp_Perms.js",
	"read.history": ":lib:wsp/wsp_Perms.js",
	"restore.history": ":lib:wsp/wsp_Perms.js",
	"create.airItem": ":lib:wsp/wsp_Perms.js",
	"moveFrom.item.toAir": ":lib:wsp/wsp_Perms.js",
	"callTransition.item": ":lib:wsp/wsp_Perms.js",
	"create.item": ":lib:wsp/wsp_Perms.js",
	"rename.item": ":lib:wsp/wsp_Perms.js",
	"write.item.resp": ":lib:wsp/wsp_Perms.js",
	"read.node": ":lib:wsp/wsp_Perms.js",
	"read.node.export": ":lib:wsp/wsp_Perms.js",
	"read.node.reveal": ":lib:wsp/wsp_Perms.js",
	"read.node.search": ":lib:wsp/wsp_Perms.js",
	"read.node.web": ":lib:wsp/wsp_Perms.js",
	"create.space": ":lib:wsp/wsp_Perms.js",
	"rename.space": ":lib:wsp/wsp_Perms.js",
	"read.repos.task": ":lib:wsp/wsp_Perms.js",
	"read.task": ":lib:wsp/wsp_Perms.js",
	"read.task.search": ":lib:wsp/wsp_Perms.js",
	"write.task": ":lib:wsp/wsp_Perms.js",
	"write.task.delete": ":lib:wsp/wsp_Perms.js",
	"deletePermanently.trash": ":lib:wsp/wsp_Perms.js",
	"read.trash": ":lib:wsp/wsp_Perms.js",
	"restore.trash": ":lib:wsp/wsp_Perms.js",
	"create.version": ":lib:wsp/wsp_Perms.js",
	"read.version": ":lib:wsp/wsp_Perms.js",
	"write.node": ":lib:wsp/wsp_Perms.js",
	"write.node.copyTo": ":lib:wsp/wsp_Perms.js",
	"write.node.create": ":lib:wsp/wsp_Perms.js",
	"write.node.delete": ":lib:wsp/wsp_Perms.js",
	"write.node.duplicate": ":lib:wsp/wsp_Perms.js",
	"write.node.import": ":lib:wsp/wsp_Perms.js",
	"write.node.moveFrom": ":lib:wsp/wsp_Perms.js",
	"write.node.moveTo": ":lib:wsp/wsp_Perms.js",
	"write.node.rename": ":lib:wsp/wsp_Perms.js",
	"write.node.setMeta": ":lib:wsp/wsp_Perms.js",
	"write.node.update": ":lib:wsp/wsp_Perms.js",
	"delete.skinPack": ":lib:wsp/wsp_Perms.js",
	"download.skinPack": ":lib:wsp/wsp_Perms.js",
	"install.skinPack": ":lib:wsp/wsp_Perms.js",
	"show.skinPack": ":lib:wsp/wsp_Perms.js",
	"admin.wsp": ":lib:wsp/wsp_Perms.js",
	"create.wsp": ":lib:wsp/wsp_Perms.js",
	"create.wsp.import": ":lib:wsp/wsp_Perms.js",
	"delete.wsp": ":lib:wsp/wsp_Perms.js",
	"create.wsp.drf": ":lib:wsp/wsp_Perms.js",
	"create.wsp.drv": ":lib:wsp/wsp_Perms.js",
	"exportConfig.wsps": ":lib:wsp/wsp_Perms.js",
	"list.wsps": ":lib:wsp/wsp_Perms.js",
	"migrate.wsp": ":lib:wsp/wsp_Perms.js",
	"read.wsp": ":lib:wsp/wsp_Perms.js",
	"reload.wsp": ":lib:wsp/wsp_Perms.js",
	"remove.cache.wsp": ":lib:wsp/wsp_Perms.js",
	"update.wsp": ":lib:wsp/wsp_Perms.js",
	"use.wsp": ":lib:wsp/wsp_Perms.js",
	"admin.wspInTrash": ":lib:wsp/wsp_Perms.js",
	"deletePermanently.wspInTrash": ":lib:wsp/wsp_Perms.js",
	"list.wspsInTrash": ":lib:wsp/wsp_Perms.js",
	"read.wspInTrash": ":lib:wsp/wsp_Perms.js",
	"restore.wspInTrash": ":lib:wsp/wsp_Perms.js",
	"dowload.wspPack": ":lib:wsp/wsp_Perms.js",
	"install.wspPack": ":lib:wsp/wsp_Perms.js",
	"list.wspPacks": ":lib:wsp/wsp_Perms.js",
	"uninstall.wspPack": ":lib:wsp/wsp_Perms.js",
	"edit.job": ":lib:core/core_Perms.js",
	"show.jobs": ":lib:core/core_Perms.js",
	"show.myJobs": ":lib:core/core_Perms.js",
	"admin.logs": ":lib:core/core_Perms.js",
	"use.packs": ":lib:wsp/wsp_Perms.js",
	"set.maintenance": ":lib:core/core_Perms.js",
	"use.inMaintenance": ":lib:core/core_Perms.js",
	"admin.users": ":lib:commons/utils/user_Perms.js",
	"admin.props.isHidden.group": ":lib:commons/utils/user_Perms.js",
	"admin.typeGroup": ":lib:commons/utils/user_Perms.js",
	"create.group": ":lib:commons/utils/user_Perms.js",
	"drop.group": ":lib:commons/utils/user_Perms.js",
	"update.group": ":lib:commons/utils/user_Perms.js",
	"admin.props.isHidden.user": ":lib:commons/utils/user_Perms.js",
	"admin.typeUser": ":lib:commons/utils/user_Perms.js",
	"create.user": ":lib:commons/utils/user_Perms.js",
	"drop.user": ":lib:commons/utils/user_Perms.js",
	"update.user": ":lib:commons/utils/user_Perms.js",
	"use.users": ":lib:commons/utils/user_Perms.js",
	"admin.device": ":lib:client/client_Perms.js",
	"debug.device": ":lib:client/client_Perms.js",
	"admin.device.server": ":lib:client/client_Perms.js",
	"use.device": ":lib:client/client_Perms.js",
	"read.Cluster": ":lib:saas/saas_Perms.js",
	"use.instsClusterMgr": ":lib:saas/saas_Perms.js",
	"write.Cluster": ":lib:saas/saas_Perms.js",
	"read.Inst": ":lib:saas/saas_Perms.js",
	"write.Inst": ":lib:saas/saas_Perms.js",
	"admin.UTNode": ":lib:store/store_Perms.js",
	"admin.UTNode.configRoles": ":lib:store/store_Perms.js",
	"upload.UTNode.content": ":lib:store/store_Perms.js",
	"edit.UTNode.metas": ":lib:store/store_Perms.js",
	"read.UTNode": ":lib:store/store_Perms.js",
	"read.UTNode.webView": ":lib:store/store_Perms.js",
	"write.UTNode": ":lib:store/store_Perms.js",
	"write.UTNode.relist": ":lib:store/store_Perms.js",
	"write.UTNode.remove": ":lib:store/store_Perms.js",
	"write.UTNode.trash": ":lib:store/store_Perms.js",
	"write.UTNode.unlist": ":lib:store/store_Perms.js",
	"write.UTNode.untrash": ":lib:store/store_Perms.js",
	"view.depot": ":lib:store/store_Perms.js",
}